<template>
	<div :id="modalName">
		<b-modal :id="modalName" title="Edit Attribute" scrollable hide-footer size="sm">
            <template v-slot:modal-title>
                <span>Edit Attribute:</span>
            </template>

            <b-form @submit.stop.prevent="editAttribute">
                <b-row>
                    <b-col>
                        <b-form-group
                            id="input-group-name"
                            label="Name:"
                            label-for="input-name"
                            label-size="sm"
                        >
                            <b-form-input
                                id="input-name"
                                v-model="edit.name"
                                type="text"
                                placeholder=""
                                size="sm"
                                autocomplete="off"
                            >
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-form-row class="button-row">
                    <b-col cols=2>
                        <b-button type="submit" variant="primary" class="btn-sm">
                            <span v-if="submitting">
                                <b-spinner small type="grow"></b-spinner>
                                Editing...
                            </span>
                            <span v-else>Edit</span>
                        </b-button>
                    </b-col>
                </b-form-row>
            </b-form>
        </b-modal>
	</div>
</template>

<script>
	export default {
		props: [
            'row'
		],

		components: {

		},

		data() {
			return {
				modalName: 'modal-inventory-attributes-edit-attribute',
                edit: {
                    id: '',
                    name: ''
                },
                submitting: 0,
			}
		},

		methods: {
            editAttribute() {
                this.submitting = 1
                let editData = this.edit

                let url = 'api/inventory/attributes/editattribute'
                axios.post(url, {
                    editData
                })
                .then((res) => {
                    this.submitting = 0

                    let status = res.data.status
                    if (status == 'success') {
                        this.closeModal(this.modalName)
                        this.showAlertBox('success', 'Attribute Edited', 'Attribute edited successfully!')
                        this.$emit('getAttributes')
                    } else if (status == 'duplicate') {
                        this.showAlertBox('success', 'Duplicate Attribute', 'Attribute already exists! Please try something else!')
                    } else {
                        this.showAlertBox('error', 'Error', 'Error editing attribute!')
                    }
                }, () => {
                    this.has_error = true
                })
            }
		},

		computed: {

		},

		mounted() {
            this.edit.name = this.row.name
            this.edit.id = this.row.id
		}
	}
</script>
<style lang="scss">
    #modal-inventory-attributes-edit-attribute {
        .modal-content {
            .button-row {
                margin-top: 15px;
            }
        }
    }
</style>
